var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-vue",style:({ width: _vm.width, borderRadius: _vm.borderRadius }),on:{"click":function($event){return _vm.action()}}},[_vm._t("icon"),_vm._v("\n  "+_vm._s(_vm.title)+"\n")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }